import TablaConciliacion from "../../../TablaConciliacion";

function TablaAutopistaUraba() {
  return <TablaConciliacion nombreUseCase="AUTOPISTAURABA" titulo="AUTOPISTA URABA" />;
}

export default TablaAutopistaUraba;
